import http from '../helpers/http';

const HireDocuments = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async () => {
      const result = await http.get(`/hire-documents`, {
        headers,
      });
      return result.data;
    },
    show: async (id: string, opts?: { includeDrafts?: boolean }) => {
      const result = await http.get(`/hire-documents/${id}`, {
        headers,
        params: opts?.includeDrafts ? { includeDrafts: 'true' } : undefined,
      });
      return result.data;
    },
    create: async (body: any) => {
      const result = await http.post(`/hire-documents`, body, { headers });
      return result.data;
    },
    delete: async (id: string, params?: any) => {
      const result = await http.delete(`/hire-documents/${id}`, {
        headers,
        params,
      });
      return result.data;
    },
    approve: async (id: string, body: any = {}) => {
      const result = await http.post(`/hire-documents/${id}/approve`, body, {
        headers,
      });
      return result.data;
    },
    uploadFile: async (userId: string, type: string, body: FormData) => {
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.patch(`/hire-documents/${userId}/document/${type}`, body, headers);
      return result.data;
    },
  };
};

export default HireDocuments;
